export default {
    "fit": "fit",
    "flip": "flip"
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-popup-common/dist/es/collision.js
// module id = 509
// module chunks = 0